<template>
  <v-btn text block @click="getPaymentPlanReportUrl" :disabled="loading" :loading="loading" class="report-button" v-if="$vuetify.breakpoint.mdAndUp">
    <v-icon class="mr-4">
      fas fa-download
    </v-icon>
    <span class="color-new-link-blue--text">{{ $t('reconciliationButton') }}</span>
  </v-btn>
  <span @click="getPaymentPlanReportUrl" :disabled="loading" :loading="loading" v-else>
    {{ $t('reconciliationButton') }}
  </span>
</template>

<script>
  import { apiResource } from '@/util/resources'

  export default {
    props: ['msnr'],
    data: function () {
      return {
        loading: false
      }
    },
    methods: {
      getPaymentPlanReportUrl () {
        this.$matomo && this.$matomo.trackEvent("Information", "Download Report", "Print Reconciliation Information")
        var url = '/api/reconciliation/file/ms/' + this.msnr
        this.loading = true

        apiResource({ method: 'get', url: url, responseType: 'arraybuffer' }).then((response) => {
          this.loading = false
          let blob = new Blob([response.data], { type: 'application/pdf' })
          // IE10+ : (has Blob, but not a[download] or URL)
          if (navigator.msSaveBlob) {
            return navigator.msSaveBlob(blob, this.$t('reconciliationDocument') + '.pdf')
          } else {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = this.$t('reconciliationDocument') + '.pdf'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }).catch((errorResponse) => {
          this.loading = false
          this.$store.commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
        })
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "reconciliationButton": "Lataa sovintosopimus (pdf)",
  "reconciliationDocument": "Sovintosopimus"
  },
  "se": {
  "reconciliationButton": "Ladda förlikningsavtal (pdf)",
  "reconciliationDocument": "Förlikningsavtal"
  },
  "en": {
  "reconciliationButton": "Download settlement agreement (pdf)",
  "reconciliationDocument": "Settlement"
  }
  }
</i18n>
